export class ToastModel {
    public id: number;

    constructor(
        public content: string,
        public type?: ToastType,
        public title?: string,
        public style?: string,
        public titleIcon?: JSX.Element,
    ) {
        this.id = new Date().valueOf();
    }
}

export enum ToastType {
    Info = 'info',
    Success = 'success',
    Warning = 'warning',
    Error = 'error',
    Custom = 'custom',
}

export enum ToastPosition {
    TopRight = 'top-right',
    TopLeft = 'top-left',
    BottomLeft = 'bottom-left',
    BottomRight = 'bottom-right',
}
